import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row } from 'antd';
import { Link, Route, Routes } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';

import { useTranslation } from 'react-i18next';
import useVacancyCategories from '../useVacancyCategories';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../hooks/useUser';

const MainPage = () => {
  const {
    data,
    columns,
    loading,
    onDelete,
    updateInProcess,
    onChangeTableFilter,
  } = useVacancyCategories();
  const { t } = useTranslation();
  const pages = useRecoilValue(getPage);

  return (
    <>
      <PageHeader title={t('Profilo candidato').toUpperCase()}>
        <Row gutter={16}>
          {pages?.ability?.can_create && (
            <Col>
              <Link to={'new'}>
                <Button width={'138px'} big icon={<PlusOutlined />}>
                  {t('NUOVO')}
                </Button>
              </Link>
            </Col>
          )}
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Table
          columns={columns}
          dataSource={data?.vacancy_categories}
          onChange={onChangeTableFilter}
          pagination={data?.pagination}
          loading={loading}
          scroll={{ x: 1500 }}
          // bordered
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal loading={updateInProcess} onClickDelete={onDelete} />
          }
        />
      </Routes>
    </>
  );
};

export default MainPage;
